import React, { forwardRef, useImperativeHandle, useRef } from "react";
import { searchClubs } from "../../actions";
import ClubItemMedium from "../items/club/medium";
import AutocompleteInput, { RenderFunction } from "../autocompleteInput";
import { Club, ClubAutocompleteResult } from "../../types";

const renderSuggestion: RenderFunction = (club: ClubAutocompleteResult) => (
	<ClubItemMedium name={club.name} meta={club.city} photoUrl={club.photoUrl} />
);

type Props = {
	value?: string;
	onChange?: (value: string) => void;
	onSelect: (suggestion: ClubAutocompleteResult) => void;
	placeholder?: string;
	renderFunction?: RenderFunction;
	replaceValueOnSelect?: boolean;
};

const ClubInput = (
	{ value, onChange, onSelect, placeholder, renderFunction = renderSuggestion, replaceValueOnSelect = true }: Props,
	ref
) => {
	const input = useRef<typeof AutocompleteInput>();

	useImperativeHandle(ref, () => ({
		clear: () => {
			if (input.current) {
				//@ts-ignore
				input.current.clear();
			}
		},
	}));

	const handleChange = async (value: string): Promise<Club[]> => {
		if (onChange) {
			onChange(value);
		}
		return await searchClubs(value);
	};

	const handleItemSelect = (suggestion: ClubAutocompleteResult) => {
		if (onChange) {
			onChange(suggestion.clubId);
		}
		if (onSelect) {
			onSelect(suggestion);
		}
	};

	return (
		<AutocompleteInput
			value={value}
			placeholder={placeholder}
			onChange={handleChange}
			getSuggestionValue={suggestion => suggestion.name}
			renderSuggestion={renderFunction}
			onItemSelected={handleItemSelect}
			replaceValueOnSelect={replaceValueOnSelect}
			ref={input}
		/>
	);
};

export default forwardRef(ClubInput);
